export default "__VITE_PUBLIC_ASSET__8b990e3c__"